import roomstayBlogCaseStudies, { Props as RoomstayBlogCaseStudiesProps } from '@/components/roomstay-blog-case-studies/roomstay-blog-case-studies';
import { BuilderConfig } from '@/types/builder';

export const RoomstayBlogCaseStudiesConfig = {
    name: 'Case Studies',
    inputs: [
        {
            name: 'offset',
            type: 'number',
        },
        {
            name: 'cards',
            type: 'array',
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'image',
                    type: 'file',
                },
                {
                    name: 'type',
                    type: 'string',
                },
                {
                    name: 'tag',
                    type: 'string',
                },
                {
                    name: 'url',
                    type: 'string',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<RoomstayBlogCaseStudiesProps> = {
    component: roomstayBlogCaseStudies,
    config: RoomstayBlogCaseStudiesConfig,
};

export default builderConfig;
